import { useMemo, useState } from "react";

/** List of folders to choose a destination from, with a filter box. */
export default function FolderPicker({ folders, onPick, excludePath }) {
  const [filter, setFilter] = useState("");

  const options = useMemo(() => {
    const all = ["", ...folders].filter((f) => f !== excludePath);
    const q = filter.trim().toLowerCase();
    return q ? all.filter((f) => f.toLowerCase().includes(q)) : all;
  }, [folders, filter, excludePath]);

  return (
    <div className="folder-picker">
      <input
        autoFocus
        className="folder-picker-search"
        placeholder="Type to filter folders…"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && options.length) onPick(options[0]);
        }}
      />
      <ul className="folder-picker-list">
        {options.map((f) => (
          <li key={f || "/"} onClick={() => onPick(f)}>
            {f || "/ (root)"}
          </li>
        ))}
        {options.length === 0 && <li className="folder-picker-empty">No matching folders</li>}
      </ul>
    </div>
  );
}
